const isPlatformSubdomain = (subdomain: string) => (
  subdomain === "platform" || subdomain === "eu-platform" || subdomain === "platform-staging"
);

export default isPlatformSubdomain;
